module.exports = __webpack_public_path__ + "static/media/careers-circles.aa4b6ec1.svg";